import { supabase } from './supabase';

const TOKEN_STORAGE_KEY = 'supabase_token';

const persistToken = (token: string | null) => {
  if (typeof window !== 'undefined') {
    if (token) {
      localStorage.setItem(TOKEN_STORAGE_KEY, token);
    } else {
      localStorage.removeItem(TOKEN_STORAGE_KEY);
    }
  }
};

export const storeSupabaseToken = (token: string) => {
  persistToken(token);
};

export const getStoredSupabaseToken = (): string | null => {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(TOKEN_STORAGE_KEY);
};

export const clearSupabaseToken = () => {
  persistToken(null);
};

export const getSupabaseSessionToken = async (): Promise<string | null> => {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  if (token) {
    persistToken(token);
    return token;
  }
  return getStoredSupabaseToken();
};

export const signInWithEmailPassword = async (email: string, password: string): Promise<string> => {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password,
  });

  if (error) {
    throw error;
  }

  const token = data.session?.access_token;
  if (!token) {
    throw new Error('Supabase authentication did not return a token');
  }

  persistToken(token);
  return token;
};

export const signUpWithEmailPassword = async (email: string, password: string): Promise<string> => {
  const { data, error } = await supabase.auth.signUp({
    email,
    password,
  });

  if (error) {
    throw error;
  }

  const session = data.session ?? (await supabase.auth.getSession()).data.session;
  const token = session?.access_token;
  if (!token) {
    throw new Error('Supabase registration did not yield a token');
  }

  persistToken(token);
  return token;
};

export const signOutSupabase = async () => {
  await supabase.auth.signOut();
  persistToken(null);
};

export const getSupabaseUser = async () => {
  const { data } = await supabase.auth.getUser();
  return data.user;
};
